import PurchasesTable from '@components/common/Table/PurchasesTable';
import React from 'react';

const Purchases = ({ 
  getSeachExcel, 
  getPaymentExcel, 
  getMonthlyFinanceList, 
  monthlyFinanceList, 
  monthlyFinanceListTotal,
  monthlyFinanceListTotalAmount,
  projectName, 
  companyName, 
  setProjectName, 
  setCompanyName,
  page,
  setPage,
  limit,
  setLimit,
  orderBy,
  setOrderBy,
  orderDir,
  setOrderDir
}) => {
  return <PurchasesTable 
    getSeachExcel={getSeachExcel} 
    getPaymentExcel={getPaymentExcel} 
    getMonthlyFinanceList={getMonthlyFinanceList} 
    monthlyFinanceList={monthlyFinanceList} 
    monthlyFinanceListTotal={monthlyFinanceListTotal}
    monthlyFinanceListTotalAmount={monthlyFinanceListTotalAmount}
    projectName={projectName} 
    companyName={companyName} 
    setProjectName={setProjectName} 
    setCompanyName={setCompanyName} 
    page={page} 
    setPage={setPage} 
    limit={limit} 
    setLimit={setLimit} 
    orderBy={orderBy}
    setOrderBy={setOrderBy}
    orderDir={orderDir}
    setOrderDir={setOrderDir}
  />;
};

export default Purchases;
